import type { UrlFloorPlanName } from './types';

/*
 * Floor Plans Metadata
 */
export const FLOOR_PLANS_METADATA_TITLE = `Cornerstone Homes | Explore Our Custom Home Floor Plans`;

export const FLOOR_PLANS_METADATA_DESC = `Explore our wide range of customizable floor plans designed to suit every lifestyle and budget. From open-concept layouts to traditional styles, find the perfect blueprint for your dream home with Cornerstone Homes in Oklahoma.`;

export const FLOOR_PLANS_NAMES: UrlFloorPlanName[] = [
  'willow',
  'redbud',
  'kingston',
  'sage',
  'serenity',
  'birch',
  'hyacinth',
  'elderberry',
  'harmony',
  'hickory',
  'country-living',
  'mulberry',
  'river-ranch',
];
